<template>
  <div>
    <div class="container" v-if="fill_info == ''">
      <div class="row">
        <div class="col-xs-12">
          <div class="form-title">Rendszeres szociális támogatás és költségtérítés mérséklés reklamáció</div>
        </div>
        <div class="col-xs-10">
          <div :class="{admin: uzenet.Felhasznalotol == 0}" v-for="(uzenet, i) in uzenetek" class="message-row">
            <div class="photo">
              <img v-if="uzenet.Felhasznalotol == 1" :src="'data:image/png;base64,'+$root.user.jpegphoto" alt=""/>
              <img v-if="uzenet.Felhasznalotol == 0" src="assets/img/admin-profile.png" alt=""/>
            </div>
            <div class="date">
              {{ uzenet.Idopont }}
            </div>
            <div class="text" v-html="uzenet.Uzenet">

            </div>
          </div>
          <div v-if="!ujUzenet" class="info-box warning" style="margin-top: 20px;">
            <span class="highlight">Figyelem!</span> Új üzenet írása csak adminisztrátori válasz után lehetséges.
          </div>
          <div v-if="ujUzenet" class="message-row">
            <div class="photo">
              <img :src="'data:image/png;base64,'+$root.user.jpegphoto" alt=""/>
            </div>
            <textareabox :errors="errors" placeholder="Kérjük írja le reklamációját..." cstyle="min-height: 100px" iconclass="fa fa-pencil" :autogrow="true" maxlength="1000" id="Uzenet" label="" name="Uzenet" v-model="form.Uzenet"/>
            <button :disabled="!save_enabled" v-on:click="save" type="button" class="button">Reklamáció elküldése</button>
          </div>
        </div>
      </div>
    </div>
    <div class="container" v-show="fill_info != ''">
      <div class="row">
        <div class="col-xs-12">
          <div class="form-title">Rendszeres szociális támogatás és költségtérítés mérséklés reklamáció</div>
          <div class="article-text" v-html="fill_info"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

export default {
  components: {
  },

  data: function() {
    return {
      fill_info: '',
      save_enabled: true,
      errors: [],
      uzenetek: [],
      ujUzenet: false,
      form: {
        Uzenet: ''
      }
    }
  },
  mounted: function() {
  	var _this = this;
    _this.getUzenetek();
  },
  methods: {
    getUzenetek: function() {
      var _this = this;
      this.$root.ajax('hatar/rendszeres_szockerelem_reklamacio_uzenetek', {
        method: 'GET',
        success: function(response) {
          if (response.error == false) {
            if (response.uzenetek.length > 0) {
              _this.uzenetek = response.uzenetek;
              _this.ujUzenet = response.utolso_felhasznalotol == 1 ? false : true;
            } else {
              _this.ujUzenet = true;
            }

          } else {
            _this.fill_info = response.error;
          }
        }
      });
    },

    save: function() {
      var _this = this;

      this.errors = [];
      this.save_enabled = false;

      this.$root.ajax('hatar/rendszeres_szockerelem_reklamacio_ment', {
        data: {
          form: this.form
        },
        method: 'POST',
        success: function(response) {
          _this.save_enabled = true;

          if (response.errors != undefined && response.errors.length > 0) {
            _this.errors = response.errors;

            Vue.nextTick(function() {
              $('html, body').animate({
                scrollTop: $('#' + _this.errors[0].id).offset().top - 50
              }, 500);
            })

          } else if (response.error) {
            swal('Hiba!', response.error, 'error');

          } else {
            _this.form.Uzenet = '';
            _this.ujUzenet = false;
            _this.getUzenetek();
          }
        }
      });
    }
  }
}
</script>


// WEBPACK FOOTER //
// rendszeres_szocialis_reklamacio.vue?11fb64e4